import { catchError, finalize, debounceTime, tap, take, switchMap } from 'rxjs/operators';
import {
  Component,
  Input,
  AfterContentInit,
  EventEmitter,
  Output,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  FieldConfig,
  DataRetrieverConfig,
  FieldAction,
  FormUpdateMode,
  IEvaluableExecutor
} from '../../api/contract-notice-dto';
import {
  SearchSettingDTOModal,
  searchGenericComponent
} from '../search/searchGeneric.component';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { deNormalizaDossierId, FileDetailsDTO } from '../../api/plyca-dtos';
import { getSimpleIdentifierFromString, I18nData } from '../../api/plyca-dtos';
import { ActionParameterDefinitionDTO, CompanyDTO } from '../../api/plyca-dtos-v2';
import { searchOrganizationalUnitsComponent } from '../searchOrganizationalUnits/searchOrganizationalUnits.component';
import {
  FormGroup,
  AbstractControl,
  FormBuilder
} from '@angular/forms';
import { FormService } from './form.service';
import { searchCPVComponent } from '../searchCPV/searchCPV.component';
import { searchReportComponent } from '../searchReport/searchReport.component';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  FunctionDef,
  ErrorFieldGroup,
  ERRORTYPE,
  filterErrors,
  FormConfig,
  FormDialogResponse,
  AcceptFormAction,
  TemplateDef,
  BaseFormAction
} from './form.objects';
import { UUID } from 'angular2-uuid';
import { DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { formPlycaComponent } from './formPlyca.component';
import { TableFormGroup } from './tableFormGroup';
import { Observable, of } from 'rxjs';
import { HelpService } from '../common/help/help.service';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { Configuration } from '../../conf/app.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DivisionTreeComponent } from '../divisionTree/divisionTree.component';
declare var jQuery: any;
import * as XLSX from 'xlsx';
import { LongTextEditorComponent, LongTextDTOModal } from './longTextEditor.component';
import { PropertyService } from '../../properties/property.service';
import { BaseComponent } from '../common/baseComponent/base.component';
import { HtmlDTOModal, HtmlEditorComponent } from './htmlEditor.component';

import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
import { AppConfiguration } from '../../conf/app.configuration';
import { SelectItem, ConfirmationService, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { InputNumber } from 'primeng-lts/inputnumber';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';
import { PRIMENG_DATE_FORMAT, LanguageService } from '../../../services/language.service';
import { ViewDTOModal, CompanyAdminComponent } from '../../company/companyAdmin.component';
import { CompanyService } from '../../company/company.service';
import { UserService } from '../../user.service';
import { checkValueInArray, ensureArray, findRowIndexByUuid, getValues, processEvalExpression, removeRowFromData, updatePreviousValues } from './formElement.functions';
import { FormElementsTypes } from './formElement.const';
import { evalDescriptionNormalizer } from './formElement.normalizer';
Quill.register('modules/imageResize', ImageResize);

export class VisibilityEvent {
  id: string;
  visible: boolean;
}

@Component({
  selector: 'formElement',
  templateUrl: 'formElement.template.html',
  styleUrls: ['formElement.component.scss'],
  // Desactivamos la deteccion de cambios para mejorar el tiempo de respuesta de los formularios
  //  al teclear en campos de tipo texto o numéricos y así evitar reprocesados de las vistas
  //  innecesarios
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DialogService, UIService]
})
export class formElementComponent extends BaseComponent implements AfterContentInit, OnInit, IEvaluableExecutor /*, OnChanges*/ {
  @Input()
  model;
  /**
   * Grupo de controles del formulario al que pertenece este componente
   */
  @Input()
  formGroup: FormGroup;
  @Input()
  fieldConfig: FieldConfig;
  @Input()
  inlineComponent = false;
  @Input()
  functions: Array<FunctionDef>;
  @Input()
  templates: Array<TemplateDef>;
  @Input()
  debug = false;
  @Input()
  errors: ErrorFieldGroup;
  /**
   * Input especificos de componentes de tipo TABLE
   */
  @Input()
  index: any;
  @Input()
  columnStyle: any;

  @Input()
  changeDectectionTimestamp: Date;
  // Al cambiar la referencia completa de este campo se fuerza la actualizacion de vistas en modo ChangeDetectionStrategy.OnPush

  @Input()
  readonlyElement = false;


  @Output()
  loaded: EventEmitter<string> = new EventEmitter(undefined);

  @Output()
  valueChanged: EventEmitter<{
    oldValue: any,
    newValue: any
  }> = new EventEmitter(undefined);

  @Output()
  updateGroup: EventEmitter<boolean> = new EventEmitter(false);
  @Output()
  public visibleEvt = new EventEmitter<VisibilityEvent>();
  /**
   * Propiedades de configuracion del campo
   */
  // Control de formulario asociado. En el caso de tablas un FormGroup, en el resto FormControl
  abstractControl: AbstractControl;
  type: string;
  tooltipText: string;
  jsonField: string;
  // description;
  fieldStyle: string;
  editable: boolean | string;
  public widthSize: string;

  addEnabled: boolean | string;
  helpText: string;
  helpEntries: string[];
  data: Array<any>;
  dropDownDataKey: string;
  idBuscador: string; // =''
  orderByDescription: boolean | string;
  autoSearch: boolean;
  required: string; // =''
  maxlength: number;
  minlength: number;
  pattern: string;
  tableColumns: Array<FieldConfig>;
  tableAddFunction: string;
  tableRemoveFunction: string;
  onChangeRowFunction: string;
  onImportTableFunction: string;
  removableRows: boolean | string;
  rowActions: FieldAction[];
  inputActions: FieldAction[];
  fieldActions: FieldAction[];
  visibility: string; // = '';
  condClearFormControl: string;
  dataConfig: DataRetrieverConfig;
  textTransformation: string;
  validations: string | string[];
  tabindex: any;
  autofocus: boolean | string;
  onChangeFunction: string;
  excelLoadEnabled: boolean;
  onLostFocus: string;
  standaloneControl = false;

  allowedFileExtensions = ['*'];
  documentClass;
  styleClass = '';
  rowsAllow = 10;
  dinamicOptionsActive = false;

  dropDownFirstLoad: boolean = false;

  // elementos de configuracion tipo numerico
  elementSymbol;
  // minIntegerDigits = 1;
  // minFractionDigits = 0;
  // maxFractionDigits = 0;

  hasBeenData = false;


  public uuid;

  public ERRORTYPE = ERRORTYPE;
  private DATE_FORMAT_MOMENTJS = 'DD/MM/YYYY';
  private DATETIME_FORMAT_MOMENTJS = 'DD/MM/YYYY HH:mm';
  public PRIMENG_DATE_FORMAT = PRIMENG_DATE_FORMAT;

  public filterErrors = filterErrors;

  yesNoModel: SelectItem[];

  template: TemplateRef<any>;

  public editorModules = { imageResize: [] };

  private previousValues: Map<string, any> = new Map();
  public formElementsTypes = FormElementsTypes;

  public screenWidth: number;

  constructor(
    public propertyService: PropertyService,
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public uiService: UIService,
    private fb: FormBuilder,
    public translationService: TranslateService,
    private decimalService: DecimalPipe,
    public formService: FormService,
    private dialogService: DialogService,
    protected helpService: HelpService,
    public translate: TranslateService,
    private languageService: LanguageService,
    public deviceDetector: DeviceDetectorService,
    private confirmationService: ConfirmationService,
    protected appConfig: AppConfiguration,
    private changeDetectorRef: ChangeDetectorRef,
    private waitService: WaitLoadingService,
    private companyService: CompanyService,
    public userService: UserService
  ) {
    super();
    //TODO: Migration.18: Replace - screen.directive.
    this.screenWidth = window.innerWidth
  }

  get isValid() {
    if (this.abstractControl) {
      let resp = this.abstractControl.valid || !this.abstractControl.touched;
      return resp;
    } else {
      console.log(
        'componente sin formControl',
        this.getFormControlName(),
        this.type
      );
    }
    return true;
  }

  /**
   * Metodo que se invoca para extraer el control de un campo tipo TABLE
   * @param field
   * @param index
   */
  // private getTableCellAbstractControl(
  //   field: FieldConfig,
  //   index: number
  // ): AbstractControl {
  //   let rowUuid: string;
  //   let value = this.getNestedProperty(this.model, this.jsonField);
  //   if (value) {
  //     rowUuid = value[index].rowUuid;
  //   }
  //   return this.abstractControl.get(
  //     this.formService.getFormControlKey(field, rowUuid)
  //   );
  // }

  public getTableCellClass(rowData: any, columnConfig: FieldConfig) {
    let rowHasErrors = false;
    let cellStyle = 'p-inputtext disabled ';
    if (columnConfig && columnConfig.type) {
      cellStyle += columnConfig.type;
    }
    let errors = rowData.errors;
    if (errors && errors.server) {
      rowHasErrors = errors.server.find(serverError =>
        serverError.jsonPath.endsWith('.' + columnConfig.jsonField)
      );
      if (rowHasErrors) {
        cellStyle = cellStyle + ' ng-invalid';
      }
    }
    return cellStyle;
  }

  public getRowButtonStyle() {
    let value = this.fieldConfig.editorConfig || this.fieldConfig.rowActions ? '15%' : undefined;
    return {
      width: value
    };
  }

  public getMenuItems(row: any) {
    let menuItems: MenuItem[] = [];
    if (this?.fieldConfig?.rowActions.length > 0) {
      this.fieldConfig.rowActions.forEach(action => {
        let mn: MenuItem = {};
        this.subscribe(
          this.translate.get(action.buttonTextKey), ((res: string) => {
            mn.label = res;
          }));
        mn.icon = action.imageClass;
        mn.command = (event: Event) => {
          this.executeRowAction(action, row);
        };
        menuItems.push(mn);

      }

      )
    }

    return menuItems;

  }

  public getErrorRowControlName(index: number): string {
    let rowUuid: string;
    let value = this.getNestedProperty(this.model, this.jsonField);
    if (value) {
      rowUuid = value[index].rowUuid;
    }
    let formControlId = this.formService.getFormControlKey(this.fieldConfig);
    return this.formService.formatControlId(formControlId, rowUuid);
  }

  public getFormControlName(): string {
    let rowUuid: string;
    if (this.index > -1) {
      rowUuid = this.model.rowUuid;
    }
    let formControlId = this.formService.getFormControlKey(this.fieldConfig);
    return this.formService.formatControlId(formControlId, rowUuid);
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   this.initConfigParams();
  //   if (changes['model'] && this.type === 'TABLE') {
  //     // en el caso de cambios en el modelo la tabla por que hay nuevos registros
  //     // volver a crear todos los registros de la tabla
  //     console.log('Cambio en el modelo de la tabla inicializando controles', this.abstractControl);
  //     this.initTableFormControls();
  //   }
  // }

  ngOnInit() {
    this.uuid = generateRandomIdentifier(5);
    this.initConfigParams();
    this.fieldConfig.formElement = this;
    if (this.type === 'INTEGER') {
      this.fieldConfig.maxDecimals = 0;
      // Se establece a 13 cuando es de tipo entero, ya que sino se produce un error de deserialización
      if (this.fieldConfig.maxlength == undefined || this.fieldConfig.maxlength == null) {
        this.fieldConfig.maxlength = 13;
        this.maxlength = 13;
      }
    } else if ((this.type === 'DECIMAL' || this.type === 'CURRENCY' || this.type === 'PERCENTAGE') &&
      (!this.fieldConfig.maxDecimals && this.fieldConfig.maxDecimals !== 0)
    ) {
      this.fieldConfig.maxDecimals = 2;
    }
    // comprobar necesidad de crear un control para el componente
    if (!this.abstractControl && this.type !== 'TITLE') {
      let formControl: AbstractControl;
      if (this.type === 'TABLE') {
        this.tableColumns = this.fieldConfig?.tableColumns.map((item) => {
          const jsonFieldSort = item.jsonField + 'Sort';
          return {
            ...item,
            jsonFieldSort,
            sortFilterTable: (item.type === FormElementsTypes.SEARCH
              || item.type === FormElementsTypes.DROPDOWN
              || item.type === FormElementsTypes.MULTISELECT
            ) ? jsonFieldSort : item.jsonField,
          };
        });


        formControl = new TableFormGroup(this.getFormId(), {});
      } else {
        if (this.index !== undefined && this.model && !this.model.rowUuid) {
          // si tengo indice estoy en un registro de una tabla y debo crear el rowUuid
          // por el que buscaré el campo a continuacion
          this.model.rowUuid = UUID.UUID();
        }
        if (this.formGroup) {
          // si es una celda editable de una tabla el control ya se creo en _addRow
          formControl = this.formGroup.get(this.getFormId())
        }
        if (!formControl) {
          formControl = this.formService.createFormControl(
            this.model,
            this.fieldConfig,
            this
          );
        }
      }
      if (this.fieldConfig) {
        // asociamos campo a configuracion para errores excepto en registros de tablas
        // que se asocia la tabla entera
        if (this.index == undefined) {
          this.fieldConfig.abstractControl = formControl;
        } else {
          this.fieldConfig.abstractControl = this.formGroup;
        }
      }
      // comprobar necesidad de crear FormGroup por defecto
      if (!this.formGroup) {
        this.standaloneControl = true;
        if (this.type === 'TABLE') {
          this.formGroup = new TableFormGroup(this.getFormId(), {});
        } else {
          this.formGroup = this.fb.group({});
        }
      }
      this.formGroup.registerControl(this.getFormId(), formControl);
      this.abstractControl = formControl;
    }
  }

  ngOnDestroy(): void {
    if (this.formGroup) {
      this.formGroup.removeControl(this.getFormId());
    }
    if (this.fieldConfig) {
      this.fieldConfig.abstractControl = null
      this.fieldConfig.formElement = null;
      this.fieldConfig = null;
    }
    this.abstractControl = null;
    this.dialogService = null;
    this.formGroup = null;
    this.functions = null;
    this.templates = null;
    this.template = null;
    this.errors = null;
    super.ngOnDestroy();
  }

  ngAfterContentInit(): void {
    // variables adicionales o carga de valores
    let waitForServer = false;
    console.log(this.getFormControlName(), this.abstractControl);
    // inicializar el AbstractControl asociado al componente
    if (this.type === 'TABLE') {
      // PARCHEAR TODOS LOS ELEMENTOS PARA QUE TENGAN REFERENCIA AL PADRE
      let data = this.getNestedProperty(this.model, this.jsonField);
      console.log('inicializando tabla');
      if (data != null && data.length > 0) {
        data.forEach(row => (row['_parent'] = this.model));
      }
      // this.abstractControl.valueChanges.subscribe(val => {
      //   console.log('Cambio en el valor de la tabla ' + this.jsonField, this.abstractControl);
      //   console.log('cambio con valor ', val)
      // });
      // this.abstractControl.statusChanges.subscribe(val => {
      //   console.log('Cambio en el estado de la tabla ' + this.jsonField, this.abstractControl);
      //   console.log('cambio con estado ', val)
      // });
    } else if (this.type === 'TEMPLATE') {
      this.template = this.getTemplateRef(this.jsonField);
    } else if (this.type === 'SEARCH' && !this.idBuscador) {
      console.log(
        this.jsonField,
        this.type,
        'Para utilizar un campo de tipo buscador, hay que especificar el buscador a utilizar (parámetro idBuscador)'
      );
    } else if (this.type === 'TABLE' && !this.tableColumns) {
      console.log(
        this.jsonField,
        this.type,
        'Es obligatorio definir las columnas en un campo de tipo tabla'
      );
    } else if (this.type === 'DROPDOWN' || this.type === 'MULTISELECT') {
      waitForServer = this.initDropdown();
    } else if (this.type === 'CURRENCY') {
      this.elementSymbol = '€';
      // this.maxFractionDigits = 2;
    } else if (this.type === 'PERCENTAGE') {
      this.elementSymbol = '%';
      // this.maxFractionDigits = 0;
    } else if (this.type === 'FILE') {
      // this.documentClass = this.model.documentClass;
      if (this.documentClass && this.documentClass.configuration && this.documentClass.configuration.allowMultipleFiles) {
        this.fieldConfig.singleFile = !this.documentClass.configuration.allowMultipleFiles;
      } else {
        this.fieldConfig.singleFile = this.fieldConfig.singleFile == undefined || this.fieldConfig.singleFile;
      }
      if (this.documentClass && this.documentClass.configuration && this.documentClass.configuration.allowedFileExtensions) {
        this.allowedFileExtensions = this.documentClass.configuration.allowedFileExtensions;
      }

    } else if (this.type === 'PERCENTAGE') {
      this.visibility = 'false';
    }

    if (!this.fieldStyle) {
      this.fieldStyle = 'col-12';
    }
    if (!waitForServer) {
      this.emitElementLoaded();
    }

    // actualizar valor
    // if (this.dependsOnOtherControls()) {
    //   this.fieldConfig.dependsOn.forEach((dependOnComponentId: string) => {
    //     let dependsOnControl = this.formGroup.get(this.formService.formatControlId(dependOnComponentId));
    //     if (dependsOnControl) {
    //       let dependsOnControlObservable = dependsOnControl.valueChanges.delay(650).subscribe((value: any) => {
    //         console.log('Recalculando valor. Nuevo valor campo modificado', value);
    //         // recalcular campo
    //         this.updateValueFromDependentControls();
    //       });
    //     }
    //   })
    // }
  }

  loadDataFromSearch(idSearch: string, params: any): void {

    let searchUrl = this.configuration.SEARCH_SETTINGS_SERVICE_URL + idSearch + '/values?';

    for (let i = 0; i < params.length; i++) {
      if (i !== 0) {
        searchUrl += '&';
      }
      searchUrl += params[i].identifier + '=' + params[i].value;
    }

    let transformFunction = function (object: any): string {
      return object.singleValue;
    }.bind(this);

    let labelFunction = function (object: any): string {
      if (object.singleDescription)
        return object.singleDescription;
      else if (object.singleValue.description)
        return object.singleValue.description;
      else
        return object.singleValue;
    }.bind(this);
    this.loadDataFromService(
      searchUrl,
      labelFunction,
      transformFunction
    );

  }


  initConfigParams(): any {
    this.jsonField = this.fieldConfig.jsonField;
    this.type = this.fieldConfig.type;
    this.tooltipText = this.fieldConfig.tooltipText;
    this.editable = this.fieldConfig.editable;
    this.removableRows = this.fieldConfig.removableRows;
    this.addEnabled = this.fieldConfig.addEnabled;
    this.fieldStyle = this.fieldConfig.fieldStyle;
    this.widthSize = this.fieldConfig.widthSize;
    this.idBuscador = this.fieldConfig.idBuscador; // =''
    this.orderByDescription = this.fieldConfig.orderByDescription;
    this.dataConfig = this.fieldConfig.dataConfig;
    this.autoSearch = this.fieldConfig.autoSearch;
    this.validations = this.fieldConfig.validations;
    this.tableColumns = this.fieldConfig.tableColumns;
    this.visibility = this.fieldConfig.visibility; // = '';
    this.condClearFormControl = this.fieldConfig.condClearFormControl;
    this.helpText = this.fieldConfig.helpText;
    this.helpEntries = this.fieldConfig.helpEntries;
    this.data = this.fieldConfig.data;
    this.required = this.fieldConfig.required; // =''
    this.maxlength = this.fieldConfig.maxlength;
    this.minlength = this.fieldConfig.minlength;
    this.tableAddFunction = this.fieldConfig.tableAddFunction;
    this.tableRemoveFunction = this.fieldConfig.tableRemoveFunction;
    this.onChangeRowFunction = this.fieldConfig.onChangeRowFunction;
    this.fieldActions = this.fieldConfig.fieldActions;
    this.rowActions = this.fieldConfig.rowActions;
    this.pattern = this.fieldConfig.pattern;
    this.textTransformation = this.fieldConfig.textTransformation;
    this.tabindex = this.fieldConfig.tabindex;
    this.autofocus = this.fieldConfig.autofocus;
    this.onChangeFunction = this.fieldConfig.onChangeFunction;
    this.onLostFocus = this.fieldConfig.onLostFocus;
    this.excelLoadEnabled = this.fieldConfig.excelLoadEnabled;
    this.dropDownDataKey = this.fieldConfig.dropDownDataKey;
    if (this.fieldConfig.customField) {
      this.loadConfigFromCustomField();
    }
    if (this.fieldConfig.documentClassJsonPath) {
      this.documentClass = this.getNestedProperty(this.model, this.fieldConfig.documentClassJsonPath);
    } else {
      this.documentClass = this.model.documentClass;
    }
    this.yesNoModel = [
      // { label: '', value: null }, // Seleccionar opción
      { label: this.translationService.instant('General.yes'), value: true },
      { label: this.translationService.instant('General.no'), value: false }
    ];

    this.rowsAllow = this.fieldConfig.rowsAllow;
    this.styleClass = this.fieldConfig.styleClass;

    if (this.fieldConfig.dinamicOptionsActive != undefined) {
      this.dinamicOptionsActive = this.fieldConfig.dinamicOptionsActive;
    }

  }

  loadConfigFromCustomField() {
  }

  emitElementLoaded(): any {
    if (this.fieldConfig.defaultValue) {
      this.formService.getDefaultValue(this.model, this.fieldConfig, this);
    }
    const id = this.getFormId();
    console.log('Elemento ', id, ' informa cargado');
    this.loaded.emit(id);
    this.changeDetectorRef.detectChanges();
  }

  // private updateValueFromDependentControls() {
  //   console.log('modelo', this.model);
  //   let updatedValue = this.getValueFromDependentControls();
  //   console.log('updatedValue', updatedValue);
  //   this.setNestedProperty(this.model, this.jsonField, updatedValue);
  // }


  public isEditable(): boolean {
    if (this.readonlyElement) {
      return false;
    }
    let ret = true;
    if (typeof this.fieldConfig.editable === 'boolean') {
      return this.fieldConfig.editable;
    } else if (this.fieldConfig.editable) {
      if (this.isColEditableInline(this.fieldConfig)) {
        ret = true;
      } else {
        try {
          return this.evalExpression(this.fieldConfig.editable);
        } catch (ex) {
          console.log('Error', ex);
          ret = true;
        }
      }
    }
    return ret;
  }

  public isRequired(): boolean {
    let ret = false;
    if (typeof this.fieldConfig.required === 'boolean') {
      return this.fieldConfig.required;
    } else if (this.fieldConfig.required) {
      try {
        return this.evalExpression(this.fieldConfig.required);
      } catch (ex) {
        console.log('Error', ex);
        ret = false;
      }
    }
    return ret;
  }

  public showPerPage(): boolean {
    let ret = false;
    if (typeof this.fieldConfig.showPerPage === 'boolean') {
      return this.fieldConfig.showPerPage;
    } else if (this.fieldConfig.showPerPage) {
      try {
        return this.evalExpression(this.fieldConfig.showPerPage);
      } catch (ex) {
        console.log('Error', ex);
        ret = false;
      }
    }
    return ret;
  }

  public isOrderByDescription(): boolean {
    let ret = true;

    if (typeof this.fieldConfig.orderByDescription === 'boolean') {
      return this.fieldConfig.orderByDescription;
    } else if (this.fieldConfig.orderByDescription) {
      try {
        return this.evalExpression(this.fieldConfig.orderByDescription);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public isEditableRow(rowData: any): boolean {
    let ret = true;
    if (typeof this.fieldConfig.editableRow === 'boolean') {
      return this.fieldConfig.editableRow;
    } else if (this.fieldConfig.editableRow) {
      try {
        return this.evalExpression(this.fieldConfig.editableRow, undefined, rowData);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public isRemovableRow(rowData: any): boolean {
    let ret = true;
    if (typeof this.fieldConfig.removableRows === 'boolean') {
      return this.fieldConfig.removableRows;
    } else if (this.fieldConfig.removableRows) {
      try {
        return this.evalExpression(this.fieldConfig.removableRows, undefined, rowData);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public showClearOption(rowData: any): boolean {
    let ret = true;
    if (typeof this.fieldConfig.showClearOption === 'boolean') {
      return this.fieldConfig.showClearOption;
    } else if (this.fieldConfig.showClearOption) {
      try {
        return this.evalExpression(this.fieldConfig.showClearOption, undefined, rowData);
      } catch (ex) {
        console.log('Error', ex); ret = true;
      }
    } return ret;
  }

  public isColEditableInline(column: FieldConfig): boolean {
    let ret = false;
    if (column.editable && typeof column.editable === 'string' && column.editable === 'inline') {
      ret = true;
    }
    return ret;
  }

  // Indica si el boton de annadir esta visible en las tablas
  public isAddEnabled(): boolean {
    let ret = true;
    if (typeof this.fieldConfig.addEnabled === 'boolean') {
      return this.fieldConfig.addEnabled;
    } else if (this.fieldConfig.addEnabled) {
      try {
        return this.evalExpression(this.fieldConfig.addEnabled);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public getValue(): any {
    return this.getValueFormField(this.fieldConfig);
  }

  public getValueFormField(fieldConfig: FieldConfig): any {
    let value: any;
    if (fieldConfig && fieldConfig.value) {
      try {
        value = this.evalValue(fieldConfig);
      } catch (e: any) {
        console.error(
          'Error calculando el valor',
          fieldConfig,
          fieldConfig.value,
          e
        );
      }
      // actualizar valor en el modelo cada vez que se actualiza la vista
      // en este momento se tiene el valor del modelo actualizado
      this.setNestedProperty(this.model, fieldConfig.jsonField, value);
    } else if (!fieldConfig?.jsonField) {
      return null;
    } else {
      value = this.getNestedProperty(this.model, fieldConfig.jsonField);
    }
    return value;
  }

  //Funcion para poder controlar desde las condiciones de visibilidad si el campo
  // tiene valor o ha tenido valor desde la carga del formulario
  public hasBeenNotEmpty() {
    if (this.hasBeenData)
      return true;
    else {
      this.hasBeenData = !this.isEmptyField(this.fieldConfig, this.getValue());
      return this.hasBeenData;
    }
  }

  //Funcion que devuelve si el valor pasado es vacio
  public isEmptyField(fieldConfig: FieldConfig, value: any) {
    if (fieldConfig.type == 'TITLE') {
      //Es un titulo. Buscamos si todos los campos hasta el siguiente titulo en el grupo estan todos vacios
      var titleFound: boolean = false;
      for (let i = 0; i < fieldConfig.fieldGroup.fieldList.length; i++) {
        if (titleFound && fieldConfig.fieldGroup.fieldList[i].type == 'TITLE')
          //Hemos recorrido hasta el siguiente titulo y ningon campo tiene valor
          return true;
        else if (titleFound && !this.isEmptyField(fieldConfig.fieldGroup.fieldList[i], this.getValueFormField(fieldConfig.fieldGroup.fieldList[i])))
          //Hemos encontrado un campo no vacio
          return false;

        if (!titleFound && fieldConfig.fieldGroup.fieldList[i].id == fieldConfig.id)
          titleFound = true;
      }
      return true;
    } else if (value == null)
      //Campo simple sin valor
      return true;
    else if (Array.isArray(value) && value.length == 0)
      //Array vacio
      return true;
    return false;
  }

  public getValueTableColumn(model: any, fieldConfig: FieldConfig): any {
    let value: any;
    if (fieldConfig && fieldConfig.value) {
      try {
        value = this.evalValue(fieldConfig, [model], { 'model': model });
      } catch (e: any) {
        console.error(
          'Error calculando el valor',
          this.fieldConfig,
          this.fieldConfig.value,
          e
        );
      }
      // actualizar valor en el modelo cada vez que se actualiza la vista
      // en este momento se tiene el valor del modelo actualizado
      this.setNestedProperty(model, fieldConfig.jsonField, value);
    } else {
      value = this.getNestedProperty(model, fieldConfig.jsonField);
    }
    return value;
  }

  private evalValue(fieldConfig, args?: any[], model?: any): any {
    return this.evalExpression(fieldConfig.value, args, model);
  }

  public evalExpression(expression: string, args?: any[], obj?: any): any {
    return this.formService.evalExpression(expression,
      (args) ? args : [this.model],
      (obj) ? obj : this,
      this,
      this.functions);
  }

  public getCheckNestedProperty(object, property) {
    let result = this.getNestedProperty(object, property);

    if (result === null || result == undefined || result === "")
      return null;

    // Lo trataremos como string
    result = ('' + result).trim().toLowerCase();

    if (result === "" || result === "0" || result === "false" || result === "falso" || result === "n" || result === "no")
      return false;

    if (result === "1" || result === "true" || result === "verdadero" || result === "s" || result === "si")
      return true;

    return result;
  }

  public getNestedProperty(object: any, property: string) {
    const value = getValues(this.formService, object, property);
    if (value === undefined) {
      return;
    }

    let previousValue = this.previousValues.get(property);
    if (!previousValue) {
      return this._handleNoPreviousValue(property, value);
    }

    const { valueArray, previousValueArray } = this._ensureValuesAreArrays(value, previousValue);
    this._updatePreviousValues(property, valueArray, previousValueArray);
    this._processEvalExpression();

    return this.type === FormElementsTypes.TEXTAREA && !value ? '' : value;
  }

  private _handleNoPreviousValue(property: string, value: any): any {
    updatePreviousValues(this.previousValues, property, value);
    return value;
  }

  private _ensureValuesAreArrays(value: any, previousValue: any): { valueArray: any[], previousValueArray: any[] } {
    const valueArray = ensureArray(value);
    const previousValueArray = ensureArray(previousValue);
    return { valueArray, previousValueArray };
  }

  private _updatePreviousValues(
    property: string,
    valueArray: any[],
    previousValueArray: any[]
  ): void {
    const isValueInArray = checkValueInArray(
      previousValueArray,
      valueArray[0],
      this.isEqualValue.bind(this)
    );

    if (!isValueInArray) {
      const updatedPreviousValueArray = [...previousValueArray, ...valueArray];
      updatePreviousValues(this.previousValues, property, updatedPreviousValueArray);
    }
  }

  private _processEvalExpression(): void {
    const evalTextTransformation = this.evalExpression(this.fieldConfig?.textTransformation);
    if (evalTextTransformation) {
      processEvalExpression(evalTextTransformation, this.fieldConfig, this.model);
    } else {
      evalDescriptionNormalizer(this.fieldConfig, this.model);
    }
  }

  public setNestedPropertyDebounced(time, obj, path, value) {
    this.subscribe(of({}).pipe(
      debounceTime(time),
      tap(() => this.setNestedProperty(obj, path, value))
    ));
  }

  public setNestedPropertyLostFocus(obj, path) {
    let value = this.getNestedProperty(obj, path);
    // let newObj = this.formService.setNestedProperty(obj, path, value);
    // let newValue = this.getNestedProperty(newObj, path);

    // 1. emitir evento (por si se ha registrado via template)

    if (this.functions && this.onLostFocus) {
      let func = this.functions.find(
        x => x.identifier === this.onLostFocus
      );
      if (func) {
        func.fn.call(this, value);
      } else {
        console.error(
          'El componente ',
          path,
          ' tiene asociada una funcion (',
          this.onLostFocus,
          ') que no existe en el formulario'
        );
      }
    }

    return value;
  }

  /**
   * Metodo utilizado para lanzar el evento de cambio al modificar una propiedad
   * Tiene dos modos de funcionamiento en funcion de la configuracion de actualizacion del formulario
   * timer -> Se mantiene condicion de  oldValue === newValue que no funciona en caso de que los valorea a comparar
   *              sean objetos por compatibilidad hacia atrás
   * OnChange -> Se hace una comprobacion recursiva de propiedades
   *
   * @param oldValue
   * @param newValue
   * @returns
   */
  private isEqualValue(oldValue: any, newValue: any): boolean {
    return (this.type !== 'YES_NO' && this.type !== 'DROPDOWN'// YES_NO y DROPDOWN debe diferenciar entre null y false
      && this.fieldConfig?.fieldGroup?.interfaceSettings?.updateMode === FormUpdateMode.ONCHANGE) ?

      lodash.isEqual(oldValue, newValue) || (!oldValue && !newValue) // tratar "" | 0 | null | undefined como lo mismo
      :
      oldValue === newValue;
  }

  public setNestedProperty(obj, path, value) {
    let oldValue = this.getNestedProperty(obj, path);
    let newObj = this.formService.setNestedProperty(obj, path, value);
    let newValue = this.getNestedProperty(newObj, path);
    if (!this.isEqualValue(oldValue, newValue)) {
      this.clearErrorsIfNeccessary();
      this.formGroup.markAsDirty();
      // 1. emitir evento (por si se ha registrado via template)
      this.valueChanged.emit({
        oldValue: oldValue,
        newValue: newValue
      });
      // 2. Si en el formulario se ha registrado una funcion onChange se invoca
      if (this.functions && this.onChangeFunction) {
        let func = this.functions.find(
          x => x.identifier === this.onChangeFunction
        );
        if (func) {
          func.fn.call(this, newObj, {
            oldValue: oldValue,
            newValue: newValue
          });
        } else {
          console.error(
            'El componente ',
            path,
            ' tiene asociada una funcion (',
            this.onChangeFunction,
            ') que no existe en el formulario'
          );
        }
      }
      // actualizar vista al cambiar modelo
      this.updateGroupView();
    }
    return newObj;
  }

  getLabelStyle(): any {
    // this.getErrors();
    // let error = this.errors && this.errors.length > 0;
    // let ret = this.errors && this.errors.length > 0 ? 'label-danger' : '';
    // console.log('GETLABELSTYLE: ', this.jsonField, ret, this.errors);
    let error = false;
    if (this.required && this.isRequired() && !this.getNestedProperty(this.model, this.jsonField)) {
      error = true;
    }
    let ret = error ? { color: 'red' } : { color: 'black' };
    return ret;
  }

  onSubmit(form) {
    console.log(form);
  }

  ////////////////////////////////////////////
  // METODOS PARA LOS COMPONENTES DE TIPO BUSCADOR (unidades organicas, cpvs y generico)
  ////////////////////////////////////////////

  openUOSearch() {
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      styleClass: 'searchStyle'
    };

    this.subscribe(this.propertyService.getProperty('VALIDITY_PERIOD_ORGANIZATIONALUNIT_ENABLED', '0'),
      (value: string) => {
        config.data = new Object();
        config.data.filterValidityPeriod = value;
      });

    if (this.fieldConfig?.parameters) {
      config.data.parameters = this.fieldConfig.parameters;
    }
    this.waitService.startWaiting();
    const ref = this.dialogService.open(
      searchOrganizationalUnitsComponent,
      config
    );
    this.subscribe(ref.onClose, (result) => {
      if (result) {

        this.setNestedProperty(this.model, this.jsonField, result);

      }
    });
    // let mod = this.modal.open(searchOrganizationalUnitsComponent);
    // mod.result.then(
    //   result => {
    //     if (result) {
    //       this.clearErrorsIfNeccessary();
    //       this.setNestedProperty(this.model, this.jsonField, result);
    //     }
    //   },
    //   () => 'Rejected!'
    // );
  }

  openCPVSearch() {
    // // Contexto que se le pasa al componente
    let contextSearch = new SearchSettingDTOModal(
      this.idBuscador,
      this.autoSearch
    );
    // contextSearch.isBlocking = true;

    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'searchStyle'
    };
    config['context'] = contextSearch;
    // this.waitService.startWaiting();
    const ref = this.dialogService.open(searchCPVComponent, config);
    this.subscribe(ref.onClose, (result) => {
      if (result) {

        this.setNestedProperty(this.model, this.jsonField, result);

      }
    });
  }

  openReportSearch() {
    let contextSearch = new SearchSettingDTOModal(
      this.idBuscador,
      this.autoSearch
    );
    // contextSearch.isBlocking = true;

    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = contextSearch;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(searchReportComponent, config);
    this.subscribe(ref.onClose, (result) => {
      if (result) {

        this.setNestedProperty(this.model, this.jsonField, result);

      }
    });
  }

  private aplyTextTransformation(): string {
    return this.evalExpression(this.textTransformation);
  }

  evalExpressionParametersURLSearch(obj): ActionParameterDefinitionDTO[] {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    try {
      if (obj) {
        let arrayLength = obj.length;
        for (let i = 0; i < arrayLength; i++) {
          let param = new ActionParameterDefinitionDTO();
          param.identifier = obj[i].identifier.trim();

          // el formElement puede tener como valor un objeto (este comportamiento se aplica inicialmente para el caso del UOSEARCH)
          if (typeof obj[i].value === 'object') {
            param.value = obj[i].value;
          } else {
            param.value = getSimpleIdentifierFromString(
              this.evalExpression(obj[i].value.trim())
            );
          }

          parametersURL.push(param);
        }
      }
    } catch (ex) {
      console.log(
        'No se han procesado los parámetros asociados a la url del buscador: ' +
        this.fieldConfig.parameters,
        ex
      );
    }
    return parametersURL;
  }

  setCustomFieldSearch() {
    let fc = this.fieldConfig;
    if (!fc.idBuscador) {
      this.idBuscador = 'CustomField';
    }

    let params = fc.parameters ? fc.parameters : [];

    // Nombre del campo personalizable
    this.setParam(fc, params, 'CUSTOM_FIELD', '\'' + fc.jsonField.replace('customFields.', '') + '\'');
    // Identificador del objeto
    if (this.model.identifier) {
      this.setParam(fc, params, 'IDENTIFIER', '$model.identifier');
    }
    // Identificador extendido
    if (this.model.extendedDataIdentifier) {
      this.setParam(fc, params, 'EXTENDED_IDENTIFIER', '$model.extendedDataIdentifier');
    }

    fc.parameters = params;

  }



  private setParam(fc: FieldConfig, params: any, name: string, value: string) {
    if (!params.find(o => o.identifier === name)) {
      let p = new ActionParameterDefinitionDTO();
      p.identifier = name;
      p.value = value;
      params.push(p);
    }
  }

  openSearchGeneric() {
    // this.waitService.startWaiting();
    let valuesDepends: Map<string, any>;

    if (this.fieldConfig && this.fieldConfig.jsonField && this.fieldConfig.jsonField.startsWith('customFields.')) {
      this.setCustomFieldSearch();
    }
    if (this.fieldConfig && this.fieldConfig.dependsOn) {
      valuesDepends = new Map<string, any>();
      this.fieldConfig.dependsOn.forEach((dependOnComponentId: string) => {
        // obtenemos el control asociado al componente del que depende
        let dependsOnControl = this.formGroup.get(
          this.formService.formatControlId(dependOnComponentId)
        );
        if (dependsOnControl) {
          // añadimos el valor al mapa
          valuesDepends.set(dependOnComponentId, dependsOnControl.value);
        }
      });
    }

    // Procesamos los parámetros requeridos para el buscador que se está intentando abrir
    let evalParameters: ActionParameterDefinitionDTO[];
    if (this.fieldConfig.parameters) {
      evalParameters = this.evalExpressionParametersURLSearch(
        this.fieldConfig.parameters
      );
    }

    // Titulo para la cabecera de la pantalla del buscador
    let searchTitle = '';
    if (this.fieldConfig.searchTitle) {
      searchTitle = this.translationService.instant(this.fieldConfig.searchTitle);
    }

    // Contexto que se le pasa al componente
    let contextSearch = new SearchSettingDTOModal(
      this.idBuscador,
      this.autoSearch,
      evalParameters
    );
    contextSearch.searchConfig = this.fieldConfig.searchConfig;
    //    let contextResult: SearchSettingDTOModal;
    // contextSearch.isBlocking = true;
    contextSearch.valuesDepends = valuesDepends;

    let config: DynamicDialogConfig = {
      header: searchTitle,
      width: '80%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = contextSearch;
    config['model'] = this.model;
    config['showWait'] = this.fieldConfig.showWait;

    // this.waitService.startWaiting();
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, (result) => {
      if (result) {
        if (this.functions && this.fieldConfig.onSearchFunction) {
          let func = this.functions.find(
            x => x.identifier === this.fieldConfig.onSearchFunction
          );
          if (func) {
            func.fn.call(this, this.model, result);
          }
        }
        if (this.fieldConfig.type === 'TABLE') { // Si es un buscador para añadir a la tabla
          if (result instanceof Array) {
            for (let i = 0; i < result.length; i++) {
              let resulAux = result[i];
              this._addRow(resulAux);
            }
          } else {
            this._addRow(result);
          }
        } else { // Si es un buscador normal sobre el propio formelement

          this.setNestedProperty(this.model, this.jsonField, result);

        }
      }
    });

    // // Contexto que se le pasa al componente
    // let contextSearch = new SearchSettingDTOModal(
    //   this.idBuscador,
    //   this.autoSearch
    // );
    // //    let contextResult: SearchSettingDTOModal;
    // contextSearch.isBlocking = true;
    // contextSearch.valuesDepends = valuesDepends;
    // let mod = this.modal.open(
    //   searchGenericComponent,
    //   overlayConfigFactory(contextSearch)
    // );
    // mod.result.then(
    //   result => {
    //     if (result) {
    //       this.clearErrorsIfNeccessary();
    //       this.setNestedProperty(this.model, this.jsonField, result);
    //     }
    //   },
    //   () => 'Rejected!'
    // );
  }

  openDivisionTree() {
    // let valuesDepends: Map<string, any>;
    // if (this.fieldConfig && this.fieldConfig.dependsOn) {
    //   valuesDepends = new Map<string, any>();
    //   this.fieldConfig.dependsOn.forEach((dependOnComponentId: string) => {
    //     // obtenemos el control asociado al componente del que depende
    //     let dependsOnControl = this.formGroup.get(
    //       this.formService.formatControlId(dependOnComponentId)
    //     );
    //     if (dependsOnControl) {
    //       // añadimos el valor al mapa
    //       valuesDepends.set(dependOnComponentId, dependsOnControl.value);
    //     }
    //   });
    // }

    // // Procesamos los parámetros requeridos para el buscador que se está intentando abrir
    // let evalParameters: ActionParameterDefinitionDTO[];
    // if (this.fieldConfig.parameters) {
    //   evalParameters = this.evalExpressionParametersURLSearch(
    //     this.fieldConfig.parameters
    //   );
    // }

    // Titulo para la cabecera de la pantalla del buscador
    let searchTitle = '';
    if (this.fieldConfig.searchTitle) {
      searchTitle = this.fieldConfig.searchTitle;
    } else {
      searchTitle = this.translationService.instant('Forms.divisionSearch.title');
    }

    // Contexto que se le pasa al componente
    // let contextSearch = new SearchSettingDTOModal(
    //   this.idBuscador,
    //   this.autoSearch,
    //   evalParameters
    // );
    // contextSearch.valuesDepends = valuesDepends;

    let config: DynamicDialogConfig = {
      header: searchTitle,
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };

    // config['dossierId'] = this.idBuscador;
    config['dossierId'] = this.idBuscador;
    if (this.fieldConfig.parameters) {
      let arrayLength = this.fieldConfig.parameters.length;
      for (let i = 0; i < arrayLength; i++) {
        if (this.fieldConfig.parameters[i].identifier.trim() === 'dossierId') {
          if (this.fieldConfig.parameters[i].value !== undefined) {
            config['dossierId'] = deNormalizaDossierId(this.evalExpression(this.fieldConfig.parameters[i].value.trim()));
          }
        } else {
          config[this.fieldConfig.parameters[i].identifier] = this.evalExpression(this.fieldConfig.parameters[i].value.trim());
        }

      }
    }
    config['filterDivisionType'] = this.fieldConfig.filterDivisionType;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(DivisionTreeComponent, config);
    this.subscribe(ref.onClose, (result) => {
      if (result) {

        this.setNestedProperty(this.model, this.jsonField, result);

      }
    });
  }

  onAddChip() {
    let chipValue = this.model[this.jsonField];
    this.setNestedProperty(this.model, this.jsonField, chipValue);
  }
  onRemoveChip() {
    let chipValue = this.model[this.jsonField];
    this.setNestedProperty(this.model, this.jsonField, chipValue);
  }


  toString(obj): string {
    let ret = '';
    if (lodash.isArray(obj)) {
      ret = obj.map(element => ret = this.toString(element)).join(' ,');
    } else if (obj && this.fieldConfig.descriptionWithID) {
      ret = getSimpleIdentifierFromString(obj.identifier) + ' - ' + obj.description;
    } else if (obj && this.fieldConfig.descriptionProperty) {
      ret = this.getNestedProperty(obj, this.fieldConfig.descriptionProperty)
    } else if (obj && this.fieldConfig.textTransformation) {
      ret = this.aplyTextTransformation();
    } else if (obj && JSON.stringify(obj, (k, v) => k === '_parent' ? undefined : v) !== '{}') {
      if (obj['__description']) {
        ret = obj['__description'];
      } else if (obj.value) {
        ret = this.toString(obj.value);
      } else if (obj.contractFolderId) {
        ret = obj.contractFolderId;
        // Woraround para cuando son atributos (nos interesa el ID, nadie conoce la descripcion)
      } else if (obj.attributeNumber) {
        ret = obj.identifier;
      } else if (obj.description) {
        ret = obj.description;
      } else if (obj.desc) {
        ret = obj.desc;
      } else if (obj.person && obj.person.fullName) {
        ret = '[' + obj.identifier + ']' + ' ' + obj.person.fullName;
      } else if (obj.fullName) {
        ret = obj.fullName;
      } else if (obj.name) {
        ret = obj.name;
      } else if (obj.contractFolderId) {
        ret = obj.contractFolderId;
      } else if (obj.identifier) {
        ret = obj.identifier;
      } else if (obj.toString) {
        ret = obj.toString();
      }
    } else {
      ret = '';
      // - No asignado -
    }
    return ret;
  }

  public getFormId(): string {
    let formControlId;
    // los identificadores con rowid solo se usan en tablas de edición inli
    if (this.index !== undefined) {
      formControlId = this.formService.getFormControlKey(this.fieldConfig, this.model.rowUuid);
    } else {
      formControlId = this.formService.getFormControlKey(this.fieldConfig);
    }
    return this.formService.formatControlId(formControlId);
  }

  ////////////////////////////////////////////
  // METODOS PARA EL COMPONENTE DE TABLA
  ////////////////////////////////////////////
  private getTableRowFormControls(rowUuid: string): Array<string> {
    // if (this.fieldConfig.editorConfig) {
    //   let value = this.getValue();
    //   if (Object.keys(value).length === 0) {
    //     this.abstractControl.setErrors(undefined);
    //   }
    // } else {
    let controlNames = new Array<string>();
    this.fieldConfig.tableColumns.forEach((column: FieldConfig) => {
      controlNames.push(this.formService.getFormControlKey(column, rowUuid));
    });
    return controlNames;
    // }
  }

  public getCellData(jsonField: string, index: number): any {
    let tableData = this.getNestedProperty(this.model, this.jsonField) as any[];
    return tableData[index]['' + jsonField];
  }
  public viewRow(rowData: any): void {
    let table = undefined;
    let clonedrowData: any;
    let addRow = (table != undefined);
    if (!rowData) {
      clonedrowData = {};

    } else {
      rowData['_parent'] = null;
      clonedrowData = lodash.cloneDeep(rowData);
      clonedrowData['_parent'] = this.model;


    }


    if (this.functions && this.fieldConfig?.preEditRowFunction) {
      let func = this.functions.find(
        x => x.identifier === this.fieldConfig?.preEditRowFunction
      );
      if (func) {
        let mod = func.fn.call(this, clonedrowData);

        if (mod instanceof Promise) {
          console.log('EL DIALOG DEVUELVE UNA PROMESA');
          mod.then(
            result => {
              console.log('PROCESANDO ADD ROW (PROMISE)');
              return this.editRowAsyn(addRow, rowData, result, table, true);
            },
            () => 'Rejected!'
          );
        } else if (mod instanceof Observable) {
          console.log('EL DIALOG DEVUELVE UN OBSERVABLE');
          this.subscribe(mod, result => this.editRowAsyn(addRow, result, table, true));
        } else {
          this.editRowAsyn(addRow, rowData, mod, table, true);
        }
      }
    } else {
      this.editRowAsyn(addRow, rowData, clonedrowData, table, true);
    }

  }
  public editRow(rowData: any, table?: any): void {
    let clonedrowData: any;
    let addRow = (table != undefined);
    if (!rowData) {
      clonedrowData = {};

    } else {
      rowData['_parent'] = null;
      clonedrowData = lodash.cloneDeep(rowData);
      clonedrowData['_parent'] = this.model;


    }


    if (this.functions && this.fieldConfig?.preEditRowFunction) {
      let func = this.functions.find(
        x => x.identifier === this.fieldConfig?.preEditRowFunction
      );
      if (func) {
        let mod = func.fn.call(this, clonedrowData);

        if (mod instanceof Promise) {
          console.log('EL DIALOG DEVUELVE UNA PROMESA');
          mod.then(
            result => {
              console.log('PROCESANDO ADD ROW (PROMISE)');
              return this.editRowAsyn(addRow, rowData, result, table, !this.isEditableRow(rowData));
            },
            () => 'Rejected!'
          );
        } else if (mod instanceof Observable) {
          console.log('EL DIALOG DEVUELVE UN OBSERVABLE');
          this.subscribe(mod, result => this.editRowAsyn(addRow, result, table, !this.isEditableRow(rowData)));
        } else {
          this.editRowAsyn(addRow, rowData, mod, table, !this.isEditableRow(rowData));
        }
      }
    } else {
      this.editRowAsyn(addRow, rowData, clonedrowData, table, !this.isEditableRow(rowData));
    }

  }
  public editRowAsyn(addRow: boolean, rowData: any, clonedRowData: any, table?: any, readonly = false): void {
    // Se puede incluir un id de la ayuda, pero no se tiene acceso al
    // nombre del fichero json
    let context = new FormConfig(undefined, undefined, clonedRowData);
    context.functions = this.functions;
    let actions = [];
    if (!readonly) {
      if (this.fieldConfig.editorConfig?.actions) {

        this.fieldConfig.editorConfig.actions.forEach((action) => {


          let func = this.functions.find(
            x => x.identifier === action.functionName
          );

          let visible = this.isVisibleAction(action, rowData);
          actions.push(
            new BaseFormAction(
              'save',
              action.buttonTextKey,
              action.buttonClass,
              action.imageClass,
              true, func.fn, visible
            )
          );

        }
        )


      } else {

        actions.push(new AcceptFormAction());


      }
    }
    context.actions = actions;
    if (typeof this.fieldConfig.editorConfig === 'string') {
      // modal de edición pasando campos

      context.interfaceSettingsId = this.fieldConfig.editorConfig;
      context.searchTags = this.fieldConfig.searchTags;

    } else {
      // modal de edicion con campos en un json de configuracion

      //    } else if (typeof this.fieldConfig.editorConfig === 'string') {
      // context.interfaceSetting = this.fieldConfig.editorConfig;
      context.interfaceSetting = lodash.cloneDeep(this.fieldConfig.editorConfig);
    }
    // context.model = rowData;
    // context.interfaceSettings = ;
    // context.isBlocking = true;
    // let overlayConfig = overlayConfigFactory(context);
    // return this.modal.open(formPlycaComponent, overlayConfig).result;

    let header = (rowData) ? rowData.description : undefined;
    let styleClass = undefined;
    if (context.interfaceSetting && context.interfaceSetting.descriptionKey) {
      header = this.translationService.instant(
        context.interfaceSetting.descriptionKey
      );
      styleClass = 'formEdition';
    }
    /*   let config: DynamicDialogConfig = {
         header: header,
         styleClass: 'formEdition',
         closeOnEscape: false
       };*/
    if (header && header.length > 100) {
      // se limita el tamaño de la descripción para evitar los
      // textos 'enormes' en la cabecera de la modal de edición
      header = header.substr(0, 100) + '...';
    }

    let config: DynamicDialogConfig = {
      header: header,
      width: '60%',
      style: { overflow: 'hidden' },
      styleClass: styleClass
    };
    if (this.fieldConfig.searchTags) {
      context.searchTags = this.fieldConfig.searchTags;
      this.subscribe(
        this.helpService.getStoreTagsObservable().pipe(
          switchMap((helpTags) => context.parentHelpTags = helpTags)));
    }
    if (readonly) {
      config['readonly'] = true;
    }

    config['formConfig'] = context;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(formPlycaComponent, config);
    // TODO revisar que se restituye la ayuda al cerrar la modal
    this.subscribe(ref.onClose.pipe(
      finalize(() => {
        console.log('Se cierra la modal de edición de fila');

      })
    ),
      (response: FormDialogResponse<any>) => {
        // this.helpService.showContextHelp(context.tagsParent);
        if (response && response.actionId !== 'cancel') {
          // lodash.merge( response.model, rowData);
          // Se modifica porque el mergeWith no borra las propiedades cuando están undefined o no existe, deja el valor actual.
          if (this.type === 'FORMEDITOR') {
            if (rowData !== undefined) {
              this.formService.merge(rowData, response.model);
            } else {
              this.setNestedProperty(this.model, this.jsonField, response.model);
            }

          } else {
            this.formService.merge(rowData, response.model);
            /*lodash.mergeWith(rowData, response.model, function (obj, src, key) {
              return src;
            });*/
            if (addRow) {
              console.log('Fin edit Row', rowData);
              if (table instanceof FormDialogResponse) {
                table = table.model;
              }
              // delete valor._parent;
              if (
                rowData &&
                Object.keys(rowData) != undefined &&
                Object.keys(rowData).length > 0
              ) {
                table.push(rowData);
                this.setNestedProperty(this.model, this.jsonField, table);
              }


            }
          }


          if (this.functions && this.onChangeRowFunction) {
            let func = this.functions.find(
              x => x.identifier === this.onChangeRowFunction
            );
            if (func) {
              func.fn.call(this, this.model);
            }
          }
          this.formGroup.markAsDirty();
          this.updateGroupView();

        }
      }
      , error => {
        console.log('Error en la modal de edición de fila');
        console.log(error);
      });

  }
  public isVisibleAction(action: FieldAction, rowData?: any): boolean {
    let ret = true;
    if (typeof action.visibility === 'boolean') {
      return action.visibility;
    } else if (action.visibility) {
      try {
        return this.evalExpression(action.visibility, [], rowData);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public execFunction(_action: FieldAction, _model?: any) {
    if (!_model) {
      _model = this.model;
    }
    let func = this.functions.find(
      x => x.identifier === _action.functionName
    );
    if (func) {
      func.fn.call(this, _model);
    }
  }

  public printActions(actions) {
    console.log(actions);
  }

  public addRow(_model?: any): void {
    let formGroup = this.abstractControl as TableFormGroup;
    if (!_model) {
      _model = this.model;
    }
    if (this.functions && this.tableAddFunction) {
      let func = this.functions.find(
        x => x.identifier === this.tableAddFunction
      );
      if (func) {
        let mod = func.fn.call(this, _model);
        console.log('add function invocada', mod);
        if (mod instanceof Promise) {
          console.log('EL DIALOG DEVUELVE UNA PROMESA');
          mod.then(
            result => {
              console.log('PROCESANDO ADD ROW (PROMISE)');
              return this.processAddRowAsyn(result);
            },
            () => 'Rejected!'
          );
        } else if (mod instanceof Observable) {
          console.log('EL DIALOG DEVUELVE UN OBSERVABLE');
          this.subscribe(mod, result => this.processAddRowAsyn(result));
        } else {
          this.processAddRowAsyn(mod);
        }
      }
    } else if (this.fieldConfig.editorConfig) {
      let tableModel = this.getValue() as any[];
      if (!tableModel) {
        tableModel = new Array<any>();
      }
      let newObjet = {};
      // Se parchea el objeto para que tenga referencia al parent
      // Hay que limpiarlo antes de enviar para que no de error de referencia circular.
      newObjet['_parent'] = this.model;

      this.editRow(newObjet, tableModel);

    } else {
      this._addRow({});
    }
  }

  public _addRow(newrow: any) {
    let obj = this.getNestedProperty(this.model, this.jsonField);

    if (!obj) {
      obj = [];
    }
    // Patch the object to avoid circular references
    newrow['_parent'] = this.model;

    obj.push(newrow);
    obj = [...obj];
    this.setNestedProperty(this.model, this.jsonField, obj);

    this.formGroup.markAsDirty();
    this.updateGroupView();
  }

  private processAddRowAsyn(result: any) {
    if (result) {
      console.log('processAddRowAsyn', result);
      let rows = [];
      if (Array.isArray(result)) {
        rows = result;
      } else {
        rows.push(result);
      }

      rows.forEach(newrow => {
        if (newrow) {
          this._addRow(newrow);
        }
      });
    }
  }

  private _removeRow(row: any, index: number) {
    let indexInData: number;
    const obj = this.getNestedProperty(this.model, this.jsonField);
    const rowUuid = row.rowUuid;

    if (rowUuid) {
      indexInData = findRowIndexByUuid(obj, rowUuid);
    } else {
      indexInData = index
    }

    if (indexInData >= 0) {
      removeRowFromData(obj, indexInData);
      this._updateModelData(obj);
      this._removeRowFromFormGroup(indexInData, rowUuid);
      this._executeOnChangeRowFunction();
      this.formGroup.markAsDirty();
      this.updateGroupView();
    }
  }

  private _updateModelData(dataArray: any[]): void {
    const updatedData = [...dataArray];
    this.setNestedProperty(this.model, this.jsonField, updatedData);
  }

  private _removeRowFromFormGroup(index: number, rowUuid: string): void {
    let formGroup = this.abstractControl as TableFormGroup;
    let tableJsonPath: string;
    let rowControlNames: Array<string>;

    if (this.fieldConfig.editorConfig) {
      tableJsonPath = this.jsonField;
    } else {
      rowControlNames = this.getTableRowFormControls(rowUuid);
    }
    formGroup.removeRow(index, rowControlNames, tableJsonPath);
  }

  private _executeOnChangeRowFunction(): void {
    if (this.functions && this.onChangeRowFunction) {
      let func = this.functions.find(
        x => x.identifier === this.onChangeRowFunction
      );
      if (func) {
        func.fn.call(this, this.model);
      }
    }
  }

  removeRow(index: number, row: any) {
    this.confirmationService.confirm({
      message: this.translationService.instant('Forms.table.deleteRow'),
      acceptLabel: this.translationService.instant('General.yes'),
      rejectLabel: this.translationService.instant('General.no'),
      accept: () => {
        if (this.functions && this.tableRemoveFunction) {
          let func = this.functions.find(
            x => x.identifier === this.tableRemoveFunction
          );
          console.log('REMOVE -> FUNC:', this.tableRemoveFunction, func);
          if (func) {
            let mod = func.fn.call(this, this.model, index, row);
            if (mod instanceof Promise) {
              console.log('REMOVE ROW DEVUELVE UNA PROMESA');
              mod.then(
                result => {
                  console.log('PROCESANDO REMOVE ROW (PROMISE)');
                  this._removeRow(row, index);
                },
                () => 'Rejected!'
              );
            } else if (mod instanceof Observable) {
              console.log('REMOVE ROW UN OBSERVABLE');
              this.subscribe(mod, result => this._removeRow(row, index));
            } else if (mod) {
              console.log('REMOVE ROW DEVUELVE UN TRUE');
              this._removeRow(row, index);
            }
          }
        } else {
          this._removeRow(row, index);
        }
      }
    });
  }

  public isActiveRowAction(action: FieldAction, rowData?: any): boolean {
    let ret = true;
    if (typeof action.enabled === 'boolean') {
      return action.enabled;
    } else if (action.enabled) {
      try {

        rowData['_parent'] = this.model;
        return this.evalExpression(action.enabled, undefined, rowData);

      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public isVisibleRowAction(action: FieldAction, rowData?: any): boolean {
    let ret = true;
    if (typeof action.visibility === 'boolean') {
      return action.visibility;
    } else if (action.visibility) {
      try {

        rowData['_parent'] = this.model;
        return this.evalExpression(action.visibility, undefined, rowData);

      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }
  public isActiveInputAction(action: FieldAction): boolean {
    let ret = true;
    if (typeof action.enabled === 'boolean') {
      return action.enabled;
    } else if (action.enabled) {
      try {
        return this.evalExpression(action.enabled);

      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public isVisibleInputAction(action: FieldAction): boolean {
    let ret = true;
    if (typeof action.visibility === 'boolean') {
      return action.visibility;
    } else if (action.visibility) {
      try {
        return this.evalExpression(action.visibility);

      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }
  public executeRowAction(action: FieldAction, _model?: any): void {
    if (!_model) {
      _model = this.model;
    }
    if (this.functions && action.functionName) {
      let func = this.functions.find(
        x => x.identifier === action.functionName
      );
      if (func) {
        let mod = func.fn.call(this, _model);


        console.log('action.functionName function invocada', mod);

      }
    }
  }
  disableExportRow(col) {
    let ret = true;
    if (col.disableExportRow === undefined) {
      ret = false;
    } else {
      try {

        ret = this.evalExpression(col.disableExportRow);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  isColVisible(col) {
    let ret = true;
    if (col.colVisibility) {
      try {
        // console.log(col.colVisibility);
        ret = this.evalExpression(col.colVisibility);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  isVisible(): boolean {
    let ret = true;
    if (this.visibility) {
      try {
        ret = this.evalExpression(this.visibility);
        if (!ret && this.abstractControl) {
          // se comproba si hay condicion de limpieza del campo, sino la hay se elimina
          // y si la hay se evalua
          if (this.condClearFormControl) {
            let retCondClearFormControl = this.evalExpression(
              this.condClearFormControl
            );
            if (!retCondClearFormControl) {
              this.clearFormControl();
            }
          } else {
            this.clearFormControl();
          }
        }
      } catch (ex) {
        console.log('Error al evaluar la expresion ', this.visibility, ' ', ex);
        ret = true;
      }
    }
    this.visibleEvt.emit({
      id: this.getFormId(),
      visible: ret
    });
    return ret;
  }

  public getCondClearFromControl(): boolean {
    let ret = false;
    if (this.condClearFormControl) {
      let retCondClearFormControl = this.evalExpression(
        this.condClearFormControl
      );
      return retCondClearFormControl;
    }
    return ret;
  }

  getDescription(): string {
    let description = this.formService.getEvalDescription(this, this.fieldConfig, this);
    // Se obtiene la descripcion del valor del modelo:
    if (description === 'get-model-value') {
      description = this.getValue();
    }
    // return this.formService.getDescription(this.fieldConfig);
    return description;
  }

  showHelp() {
    this.uiService.showMessage(
      this.helpText,
      new I18nData('General.info'),
      'helpStyle'
    );
  }

  showHelpEntries() {
    if (this.helpEntries) {
      let searchText = this.helpEntries ? this.helpEntries.join(' ') : undefined;
      // searchText = this.helpEntries[0];
      this.helpService.openSearchDialog(searchText, [this.model]);
    } else {
      console.log('NO HELPENTRIES AVAILABLES FOR ', this.jsonField);
    }
  }

  helpEntriesAvailable() {
    return (this.helpEntries && this.helpEntries.length > 0);
  }

  public clearFormControl() {
    this.setNestedProperty(this.model, this.jsonField, undefined);
  }

  public clearErrorsIfNeccessary() {
    if (this.abstractControl) {
      this.formService.clearFormControlError(this.abstractControl);
    }
  }

  ////////////////////////////////////////////
  // METODOS PARA EL COMPONENTE DE FILE UPLOAD
  ////////////////////////////////////////////

  addFileItem(fileItem: FileDetailsDTO) {

    let filesNow: Array<any>;
    filesNow = this.getNestedProperty(this.model, this.jsonField);

    if (!filesNow) {
      filesNow = [];
      this.setNestedProperty(this.model, this.jsonField, filesNow);
    }
    filesNow.push(fileItem);

  }

  deleteFileItem(fileItem: FileDetailsDTO) {
    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        let filesNow: Array<any>;
        filesNow = this.getNestedProperty(this.model, this.jsonField);

        if (filesNow) {
          console.log('Remove item ');
          let id: number;
          for (let i = 0; i < filesNow.length; ++i) {
            if (filesNow[i].identifier === fileItem.identifier) {
              id = i;
              break;
            }
          }
          filesNow.splice(id, 1);
          if (!filesNow) { filesNow = []; }
        } else {
          filesNow = [];
        }
        this.setNestedProperty(this.model, this.jsonField, filesNow);
      }
    });

  }
  modifyFileItem(items: any) {

    let fileItemToDelete: FileDetailsDTO;
    let fileItemToAdd: FileDetailsDTO;
    fileItemToDelete = items['delete'];
    fileItemToAdd = items['add'];
    // El componente upload a cargado el nuevo file y envia este evento, borramos el file que se editó
    let filesNow: Array<any>;
    filesNow = this.getNestedProperty(this.model, this.jsonField);

    if (filesNow) {
      console.log('Remove item ');
      let id: number;
      for (let i = 0; i < filesNow.length; ++i) {
        if (filesNow[i].identifier === fileItemToDelete.identifier) {
          id = i;
          break;
        }
      }
      filesNow.splice(id, 1);
      if (!filesNow) { filesNow = []; }
    } else {
      filesNow = [];
    }
    this.setNestedProperty(this.model, this.jsonField, filesNow);


    this.addFileItem(fileItemToAdd);

  }
  public setCheckValue(evt: any): void {
    if (evt != undefined) {
      this.setNestedProperty(this.model, this.jsonField, evt);
    }
  }

  ////////////////////////////////////////////
  // METODOS PARA EL COMPONENTE NUMERICO
  ////////////////////////////////////////////



  /**
   * Establecer formato fecha al campo HTML de tipo input.
   * Se cambia el valor del input en el DOM por el valor asociado al componente
   *
   * @param target Elemento HTML de tipo input a modificar
   */
  public setNumberFormat(evt: any, obj: InputNumber): void {

    this.setNestedProperty(this.model, this.jsonField, obj.value);
  }


  ////////////////////////////////////////////
  // METODOS PARA EL COMPONENTE DE DROPDOWN Y MULTISELECT
  ////////////////////////////////////////////

  public getOptions(): any {
    if (this.dataConfig && this.dataConfig.jsonPath) {
      if (this.dinamicOptionsActive) {
        // recalculamos valor
        let dataAux = this.getNestedProperty(this.model, this.dataConfig.jsonPath);
        this.loadDropdownData(dataAux, undefined, undefined);
      } else {
        if (!this.data || this.data.length == 0) {
          // recalculamos valor
          let dataAux = this.getNestedProperty(this.model, this.dataConfig.jsonPath);
          this.loadDropdownData(dataAux, undefined, undefined);
        }
      }
    }
    //Aplicamos internacionalización sobre el campo "labelKey"
    if (this.data) {
      this.data.forEach(x => {
        if (x.labelKey)
          x.label = this.translationService.instant(x.labelKey);
      });
    }
    return this.data;
  }

  private loadDataFromDataConfig(config: DataRetrieverConfig) {
    let url = this.evalExpression(config.url);
    this.loadDataFromService(url, this.getDataRetrieverConfigLabelFunction(config));
  }

  private getDataRetrieverConfigLabelFunction(config: DataRetrieverConfig) {
    let labelFunction: Function;
    if (config.labelProperty) {
      labelFunction = function (object: any) {
        return this.getNestedProperty(object, config.labelProperty)// object[config.labelProperty];
      }.bind(this);
    } else if (config.textTransformation) {
      labelFunction = function (object: any) {
        return this.evalExpression(config.textTransformation, [object]);
      }.bind(this);
    } else {
      labelFunction = function (object: any) {
        return this.toString(object);
      }.bind(this);
    }
    return labelFunction;
  }

  private loadDataFromService(url: string, labelFunction?: Function, transformFunction?: Function) {
    return this.subscribe(this.plycaService
      .query<any>(url)
      .pipe(
        catchError(
          () =>
            (this.data = [{ label: 'Error cargando los datos', value: null }])
        )
        ,
        finalize(() => this.dropDownFirstLoad = true)
      ),
      (s: PaginationDTO<any>) => {
        this.loadDropdown(s ? s.content : undefined, labelFunction, transformFunction);
        this.updateGroupView();
      });
  }

  public getMultiSelectLabel(): string {
    let label: string;
    if (!this.data || this.data.length === 0) {
      label = this.translationService.instant('General.noData');
    }
    return label;
  }

  private loadDropdown(data: any[], labelFunction?: Function, transformFunction?: Function): void {
    this.loadDropdownData(data, labelFunction, transformFunction);
    if (!this.fieldConfig.lacyLoad) {
      this.emitElementLoaded();
    }
  }

  // Inicializacion de un dorpdown
  private initDropdown(): boolean {
    let waitForServer = false;
    this.dropDownFirstLoad = false;
    let customFieldWithValues = false;
    if (!this.data && !this.idBuscador && !this.dataConfig) {
      let prefijo = 'customFields.';
      let position = this.jsonField.indexOf(prefijo);
      if (position >= 0) {
        let propertyPrefix = this.jsonField.substring(0, position);
        let customFieldName = this.jsonField.substring(position + prefijo.length);
        let customFieldDef = this.getNestedProperty(this.model, propertyPrefix + 'customFieldDefinitions.' + customFieldName);
        if (customFieldDef && customFieldDef.type === 'MasterData' && customFieldDef.origin && customFieldDef.origin.possibleValues) {
          this.data = [];
          customFieldDef.origin.possibleValues.forEach((val) =>
            this.data.push({ label: val.description, value: val })
          );
          customFieldWithValues = true;
        }
      }

      if (!customFieldWithValues) {
        console.log(
          this.jsonField,
          this.type,
          'En los campos de tipo ' +
          this.type +
          ' es obligatorio establecer los datos de carga (variable data)'
        );
        this.data = [{ label: 'Loading', value: null }];
      }
    } else if (this.dataConfig && this.dataConfig.url) {
      waitForServer = !this.fieldConfig.lacyLoad;
      console.log('COMPONENTE DE TIPO ' + this.type, this.dataConfig);
      this.loadDataFromDataConfig(this.dataConfig);
    } else if (this.idBuscador) {
      waitForServer = !this.fieldConfig.lacyLoad;
      console.log('COMPONENTE DE TIPO ' + this.type, this.idBuscador);
      //        this.data = [{ label: 'Loading', value: null }];
      if (this.fieldConfig.parameters && (this.fieldConfig.filteringMasterData == undefined
        || this.fieldConfig.filteringMasterData === false)) {
        this.loadDataFromSearch(this.idBuscador, this.fieldConfig.parameters);
      } else {
        this.loadDataFromMasterData(this.idBuscador, this.fieldConfig.parameters);
      }
    } else if (this.data || (this.dataConfig && this.dataConfig.jsonPath)) {
      let dataAux: any;
      if (this.dataConfig && this.dataConfig.jsonPath) {
        dataAux = this.getNestedProperty(this.model, this.dataConfig.jsonPath);
      } else {
        dataAux = this.data;
      }
      this.loadDropdown(dataAux);
    }
    return waitForServer;
  }

  private initLacyDropdown() {
    if (this.fieldConfig.lacyLoad) {
      this.initDropdown();
    }
  }

  private dropDownLoadingMsg(): string {
    if (!this.dropDownFirstLoad) {
      return this.translate.instant('General.loading');
    } else {
      return this.translate.instant('General.noData');
    }
  }

  private loadDropdownData(data: any[], labelFunction: Function, transformFunction: Function) {
    let list = new Array<any>();
    if (data && data.length > 0) {
      if (!this.isDropDownDataItem(data[0])) {
        let searchField = this.dropDownDataKey ? this.dropDownDataKey : 'identifier';
        const value = this.getValue();
        if (lodash.isArray(value)) {
          value.forEach(element => {
            this.checkDropdownItemLoaded(element, data, searchField);
          });
        } else {
          this.checkDropdownItemLoaded(value, data, searchField);
        }

        let labelFunctionAux = labelFunction;
        if (!labelFunction) {
          if (this.dataConfig) {
            labelFunctionAux = this.getDataRetrieverConfigLabelFunction(this.dataConfig);
          } else {
            labelFunctionAux = function (object: any): string {
              return this.toString(object);
            }.bind(this);
          }
        }
        if (!transformFunction) {
          transformFunction = function (object: any): string {
            return object;
          }.bind(this);
        }
        // convertir
        data.forEach(x => {
          list.push({ label: labelFunctionAux(x), value: transformFunction(x) });
          // if (actualValue && actualValue.identifier === x.identifier) {
          //   // el objeto devuelto por la consulta al servidor y lo que tenemos de la carga
          //   // inicial pueden no ser exactamente iguales establecer el valor de la consulta
          //   // de datos posibles del combo para que se marque como seleccionado el correcto
          //   this.setNestedProperty(this.model, this.jsonField, x);
          // }
        });
      } else {
        list = data;
      }
      this.dropDownFirstLoad = true;
    }
    // console.log('cargado combo', list);


    if (this.isOrderByDescription() && list) {
      // Se ordena el desplegable, por el contenido de la etiqueta
      let orderedList = list.sort((a, b) => {
        let descriptiona = '';
        let descriptionb = '';
        if (a && a.label) {
          descriptiona = a.label + ''; // se fuerza a tipo texto por si la etiqueta es numérica
        }
        if (b && b.label) {
          descriptionb = b.label + ''; // se fuerza a tipo texto por si la etiqueta es numérica
        }
        return descriptiona.localeCompare(descriptionb);
      });
      list = orderedList;
    }
    if (!this.dropDownDataKey && list && list.length > 0) {
      this.dropDownDataKey =
        list[0] &&
          list[0].value &&
          list[0].value.hasOwnProperty('identifier')
          ? 'identifier'
          : undefined;
    }
    this.data = list;
    // console.log('cargado combo ordenado', list);
  }

  private checkDropdownItemLoaded(value: any, data: any[], searchField: string) {
    if (value) {
      const exists = data.filter(comboValue => comboValue !== undefined)
        .find(comboValue => comboValue[searchField] === value[searchField]);
      if (!exists) {
        data.push(value);
      }
    }
  }

  /**
   * metodo que devuelve true si el dato se corresponde con un SelectItem[] o SelectItemGroup[] de un
   * DROPDOWN de prime NG
   */
  private isDropDownDataItem(data: any): boolean {
    return 'label' in data && ('value' in data || 'items' in data);
  }

  /**
   * metodo que devuelve true si el dato se corresponde con un SelectItemGroup[]
   * DROPDOWN de prime NG
   */
  isGroupingDropDown(): boolean {
    return (
      this.data &&
      this.data[0] &&
      'label' in this.data[0] &&
      'items' in this.data[0]
    );
  }

  private loadDataFromMasterData(idTabla: string, params: any) {
    let labelFunction = function (object: any): string {
      return object.description;
    }.bind(this);
    let url = this.getMasterDataValuesURL(idTabla);
    if (params) {
      url += '?'
      for (let i = 0; i < params.length; i++) {
        if (i !== 0) {
          url += '&';
        }
        if (params[i].identifier.includes('.values[') && params[i].value && params[i].value.includes('$')) {
          url += params[i].identifier + '=' + this.evalExpression(params[i].value);
        } else {
          url += params[i].identifier + '=' + params[i].value;
        }
      }
    }

    this.loadDataFromService(
      url,
      labelFunction
    );
  }



  private getMasterDataValuesURL(idTabla: string): string {
    return this.configuration.MASTERDATA_SERVICE_URL + idTabla + '/data';
  }


  ////////////////////////////////////////////
  // METODOS PARA EL COMPONENTE DE DATE | DATETIME
  ////////////////////////////////////////////

  public getValueAsDate(): Date {
    let value = this.getNestedProperty(this.model, this.jsonField);
    if (value && !(value instanceof Date)) {
      value = new Date(value);
    }
    return value;
  }

  setDateValue(obj, path, value) {
    let newValue: Date;
    if (value) {
      if (value instanceof Date) {
        newValue = value;
      } else {
        let format: string;
        if (this.type == 'DATE') {
          format = this.DATE_FORMAT_MOMENTJS;
        } else {
          format = this.DATETIME_FORMAT_MOMENTJS;
        }
        const momentValue = moment(value, format, true);
        if (momentValue.isValid()) {
          newValue = momentValue.toDate()
        }
      }
    }
    this.formService.setNestedProperty(obj, path, newValue);
  }

  public showContextHelp(): void {
    // console.log('invocando a showContextHelp desde focus');
    // this.helpService.showContextHelp(this.jsonField);
  }



  public editText(fieldId, description, disabled = false) {

    let context = new LongTextDTOModal('', '', disabled

    );


    let config: DynamicDialogConfig = {
      header: description,
      width: '50%',

      styleClass: 'formEdition'
    };

    context.label = '';
    context.text = this.getNestedProperty(this.model, this.jsonField);
    context.maxLong = this.maxlength;
    config['context'] = context;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      // undefined cuando se cancela la edición, "" cuando se borra y acepta
      if (result !== undefined) {
        this.clearErrorsIfNeccessary();
        console.log('ESTABLEDIENDO TEXTO: ');
        console.log(result);
        this.setNestedProperty(this.model, this.jsonField, result);
        this.updateGroupView();
        document.getElementById(fieldId).focus();
      }
    });
  }




  public viewText(fieldId, description?) {

    let context = new LongTextDTOModal('', '', true

    );

    let desc = '';

    if (description) {
      desc = description;
    }

    let config: DynamicDialogConfig = {
      header: desc,
      width: '50%',

      styleClass: 'searchStyle'
    };

    context.label = '';
    context.text = this.getNestedProperty(this.model, this.jsonField);
    config['context'] = context;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      document.getElementById(fieldId).focus();
      this.updateGroupView();
    });
  }






  getTemplateRef(templateName) {
    console.log('getTemplateRef: ' + templateName);
    if (this.templates) {
      let templateRef = this.templates.find(x => x.identifier === templateName);
      if (templateRef) {
        return templateRef.template;
      } else {
        console.log('ERROR TEMPLATE ' + templateName + ' NO ENCONTRADO')
      }
    }
  }

  // METODOS PARA LA FUNCIONALIDAD DE IMPORTACION Y EXPORTACION A EXCEL DE TABLAS
  // excelLoadEnabled(): boolean {
  //   return true;
  // }

  // tslint:disable-next-line:member-ordering
  @ViewChild('fileImportExcel') fileImportExcel: ElementRef;
  public openFileImportDialog(): void {
    this.fileImportExcel.nativeElement.click();
  }

  // data: Array<any> = [];
  // tslint:disable-next-line:member-ordering
  // data: AOA = [[1, 2], [3, 4]];
  // tslint:disable-next-line:member-ordering
  // data: Array<TestDTO> = [];
  // tslint:disable-next-line:member-ordering
  fileName = 'data.xlsx';
  // tslint:disable-next-line:member-ordering
  // _header = ['Code', 'Format', 'Library', 'Notes', 'Importance'];
  clear() {
    let _array = this.getNestedProperty(this.model, this.jsonField);

    for (let idx = _array.length - 1; idx >= 0; idx--) {
      this._removeRow(_array[idx], idx);
    }
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      // this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
      let _converted: Array<any> = this.convert(ws);
      // let _newArray = [];

      this.setNestedProperty(this.model, this.jsonField, []);
      let obj = this.getNestedProperty(this.model, this.jsonField);

      _converted.forEach(row => {
        // _newArray.push (row);

        let newrow = {};
        // Se parchea el objeto para que tenga referencia al parent
        // Hay que limpiarlo antes de enviar para que no de error de referencia circular.
        newrow['_parent'] = this.model;
        this.tableColumns.forEach(col => {
          let value = row[this.formService.getDescription(col, this)];
          let add = true;
          // VALIDACION DE TIPOS DE DATOS
          if (col.type === 'DECIMAL' || col.type === 'CURRENCY' || col.type === 'PERCENTAGE' || col.type === 'INTEGER') {
            if (((value != null) && (value !== '') && isNaN(Number(value)))) {
              value = '';
            }
          } else if (col.type === 'BOOLEAN') {
            if (value) {
              value = value.toLowerCase();
            }
            switch (value) {
              case true:
              case 'true':
              case 1:
              case '1':
              case 'on':
              case 'yes':
                value = true;
                break;
              default:
                value = false;
            }
          }

          if (add) {
            this.setNestedProperty(newrow, col.jsonField, value);
          }
        });

        // PATCH PARA PROPIEDADES DESGLOSADAS POR LOTES (limitado a un lote por registro por ahora)
        if (newrow['listaLotes'] && this.model.breakdownLot.lots) {
          let selectedLot = this.model.breakdownLot.lots.find(lot => lot.lotNumber == newrow['listaLotes']);
          if (selectedLot) {
            // Sobreescribir el valor de listaLotes
            newrow['listaLotes'] = [selectedLot];
          } else {
            newrow['listaLotes'] = undefined;
          }
        }

        obj.push(newrow);
        this.updateGroupView();
      });


      if (this.functions && this.fieldConfig.onImportTableFunction) {
        let func = this.functions.find(
          x => x.identifier === this.fieldConfig.onImportTableFunction
        );
        if (func) {
          func.fn.call(this, this.model);
        }
      }
      // this.setNestedProperty(this.model, this.jsonField, _newArray);
      // this.data = XLSX.utils.sheet_to_json(ws);
      console.log('XLS: ', this.data);
      this.fileImportExcel.nativeElement.value = null;
    };
    reader.readAsBinaryString(target.files[0]);



  }

  // ES NECESARIO¿?¿?¿?
  convert(ws): Array<any> {
    return XLSX.utils.sheet_to_json(ws);
  }

  export(): void {
    let _header = [];
    this.tableColumns.forEach(col => {
      if (!this.disableExportRow(col)) {
        _header.push(this.formService.getDescription(col, this))
      }

    }
    );
    /* generate worksheet */
    // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);
    // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(_data);
    let _data = this.getNestedProperty(this.model, this.jsonField);
    let _filteredData = [];
    _data.forEach(obj => {
      let _filteredObj = {};
      this.tableColumns.forEach(col => {
        if (col.jsonField === 'listaLotes') {
          let _listaLotes = this.getNestedProperty(obj, col.jsonField);
          if (_listaLotes) {
            _filteredObj[this.formService.getDescription(col, this)] = _listaLotes[0].lotNumber;
          }
        } else {
          _filteredObj[this.formService.getDescription(col, this)] = this.getNestedProperty(obj, col.jsonField);
        }
      });
      _filteredData.push(_filteredObj);
    });


    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_filteredData, {
      header: _header
    });

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  htmlEditorFullScreen() {
    console.log('requesting fullscreen');
    let config: DynamicDialogConfig = {
      header: this.getDescription(),
      styleClass: 'searchStyle fullscreen'
    };

    let context = new HtmlDTOModal('', '', true);
    context.label = '';
    context.text = this.getNestedProperty(this.model, this.jsonField);
    context.disabled = !this.isEditable();
    config['context'] = context;
    this.waitService.startWaiting();
    const ref = this.dialogService.open(HtmlEditorComponent, config);
    ref.onClose.pipe(take(1)).subscribe(result => {
      this.setNestedProperty(this.model, this.jsonField, result);
      this.updateGroupView();
    });

  }

  showFieldInfo() {
    return this.debug || this.fieldConfig.showInfo;
  }

  public showMultiValueTooltip(event: Event, overlaypanel: OverlayPanel): void {
    // mostrar panel solo si tiene valor el campo
    if (this.fieldConfig.searchConfig.multiSelection && this.getValue()) {
      overlaypanel.show(event);
    }
  }

  public getObjectStr(object: any) {
    try {
      return object ? JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)) : 'Nulo';
    } catch (e) {
      return object;
    }

  }

  private updateGroupView(): void {
    if (this.standaloneControl) {
      this.changeDetectorRef.detectChanges();
    }

    this.updateGroup.emit(true);
  }

  openWindowCompany(jsonField: string, esAlta: boolean) {


    if (esAlta) {

      let newCompany = new CompanyDTO();
      newCompany.identifier = 'new'
      this.subscribe(this.companyService.get(newCompany),
        response => {
          newCompany = response;
          this.companyService.dto2ViewModel(newCompany);
          this.showCompanyModal(newCompany, true);
        },
        err => {
          console.log(err);
        }
      );
    } else {
      let company: CompanyDTO;
      let element = this.getNestedProperty(this.model, jsonField);

      this.subscribe(this.companyService.get(element),
        response => {
          company = response;
          this.companyService.dto2ViewModel(company);
          this.showCompanyModal(company, false);
        },
        err => {
          console.log(err);
        }
      );



    }
  }
  showCompanyModal(company: CompanyDTO, esAlta: boolean) {

    let config: DynamicDialogConfig = {
      header: this.translate.instant('CompanyAdmin.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'

    };

    config['item'] = new ViewDTOModal(company, 'companyDetailISettings.json');
    config['esAltaEmpresa'] = esAlta;

    const ref = this.dialogService.open(
      CompanyAdminComponent,
      config
    );


    this.subscribe(ref.onClose,
      result => {

        if (result && result.identifier) {
          if (this.fieldConfig.type === 'TABLE') { // Si es un buscador para añadir a la tabla
            this._addRow(result);
          } else { // Si es un buscador normal sobre el propio formelement

            this.setNestedProperty(this.model, this.jsonField, result);


          }
        }

      });
  }

  today(): number {
    return Date.now();
  }

  public isEditCompanyEnabled(): boolean {
    // tslint:disable-next-line:triple-equals
    return this.toString(this.getValue()) != '' && this.evalExpression(this.fieldConfig.editCompanyEnabled);
  }

  public isAddCompanyEnabled(): boolean {
    // tslint:disable-next-line:triple-equals
    return this.toString(this.getValue()) == '' && this.evalExpression(this.fieldConfig.addCompanyEnabled);
  }

  public isSearchCompanyEnabled(): boolean {
    // tslint:disable-next-line:triple-equals
    return !this.fieldConfig.searchCompanyEnabled || this.evalExpression(this.fieldConfig.searchCompanyEnabled);
  }

  public isDeleteCompanyEnabled(): boolean {
    // tslint:disable-next-line:triple-equals
    return this.toString(this.getValue()) != ''
      && (!this.fieldConfig.deleteCompanyEnabled || this.evalExpression(this.fieldConfig.deleteCompanyEnabled));
  }

}
